import $ from 'jquery';

export default class quotemodal {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    function setModal() {
      quotemodal.i18n = i18n.QuoteModal;
    }

    if (i18n.QuoteModal) {
      quotemodal.i18n = i18n.QuoteModal;
    } else {
      setTimeout(setModal, 3000);
    }
  }

  static bindModalEvents(elm, selector) {
    $('#quoteDownloadModal .js-close-modal').on('click', function (e) {
      e.preventDefault();
      quotemodal.closeModal($(this).data('dismiss'));
    });

    $(elm).on('click', selector, function (e) {
      e.preventDefault();

      var url = $(this).attr('data-url');
      var product = $(this).attr('data-name');
      var range = $(this).attr('data-category-english-name');

      if ($(this).attr('data-ismodalenabled').toLowerCase() === 'true') {
        quotemodal.populateModalFormSalesforceField(
          'Input-Range-Models-Quote-Modal',
          product,
          range,
        );
        quotemodal.openModal(
          '#quoteDownloadModal',
          $(this).data('name'),
          $(this).data('mrrpprice'),
        );
      } else {
        if (url) {
          quotemodal.openAnotherTab(url);
        }
      }
    });

    $('#quoteDownloadModal .additional-products .js--other-products-checkbox').on(
      'change',
      function () {
        if ($(this).is(':checked')) {
          $('.js--other-poducts-comments-input').show();
        } else {
          $('.js--other-poducts-comments-input').hide();
        }
      },
    );

    $('#quoteDownloadModal .input-box.form-group .input-wrap input:not([type="hidden"])').on(
      'focus',
      function () {
        $(this).parent().addClass('active');
      },
    );

    $('#quoteDownloadModal .input-box.form-group .input-wrap input:not([type="hidden"])').on(
      'blur',
      function () {
        $(this).parent().removeClass('active');
      },
    );

    $('#quoteDownloadModal .input-box.form-group .input-wrap input:not([type="hidden"])').on(
      'keyup',
      function (e) {
        if (e.key != 'Tab') {
          window.clearTimeout(window.quoteInputTimeoutID);
          var ele = $(this);

          window.quoteInputTimeoutID = window.setTimeout(function () {
            if ($(ele).val().trim() !== null && $(ele).val().trim() !== '' && $(ele).val() != ' ') {
              if (quotemodal.isFieldValid(ele)) {
                $(ele).parent().find('.validation-tick').addClass('checked').show();
              } else {
                $(ele).parent().find('.validation-tick').removeClass('checked').hide();
              }
            } else {
              $(ele).parent().find('.validation-tick').removeClass('checked').hide();
            }
          }, 350);
        }
      },
    );
  }

  static bindModal(elm, selector) {
    quotemodal.bindModalEvents(elm, selector);

    if (!this.modalTransformed) {
      this.modalTransformed = false;
    }

    if (this.modalTransformed === false) {
      window.quoteInputTimeoutID = undefined;
      quotemodal.tranformModal(elm, selector);
      this.modalTransformed = true;
    }
  }

  static openModal(id, name, price) {
    $('body').addClass('modal-open');
    $(id).addClass('active').removeClass('fade');
    quotemodal.updateProduct(name, price);
  }

  static closeModal(id) {
    $('body').removeClass('modal-open');
    $('#' + id).addClass('fade');

    setTimeout(function () {
      $('#' + id).removeClass('active');
    }, 600);
  }

  static populateModalFormSalesforceField(fieldName, product = null, range = null) {
    const salesForceField = document.getElementById(fieldName);
    var formRangeNameField = [...document.getElementsByClassName('js-range-name')];
    var formProductNameField = [...document.getElementsByClassName('js-product-name')];

    if (salesForceField && range) {
      salesForceField.value = range;
      formRangeNameField.forEach(field => field.value = range);
    }

    if (salesForceField && product && range) {
      salesForceField.value = range + ';' + product;
      formRangeNameField.forEach(field => field.value = range);
      formProductNameField.forEach(field => field.value = product);
    }
  }

  static openAnotherTab(url) {
    var fullUrl = window.location.protocol + '//' + window.location.hostname + url;
    window.open(fullUrl, '_blank', 'noopener');
  }

  static tranformModal(elm, selector) {
    quotemodal.transformCols();
    quotemodal.updateModalWording();
    quotemodal.setEmailFieldTypes();
    quotemodal.insertOtherProductsCheckbox();
    quotemodal.insertInputValidationTicks();
  }

  static transformCols() {
    $('#quoteDownloadModal form > fieldset > div.row > div')
      .removeClass('col-sm-6 col-md-6')
      .addClass('col-sm-12 col-md-12');
  }

  static updateModalWording() {
    $('#quoteDownloadModal > div > div > div:nth-child(1) > h4').before(
      $('<p>' + quotemodal.i18n.title + '</p>'),
    );
    $('#quoteDownloadModal > div > div > div:nth-child(1)').after(
      $('<div class="modal-subheader"><p>' + quotemodal.i18n.instruction + '</p></div>'),
    );
    $('#quoteDownloadModal > div > div > div:nth-child(2)').after(
      $(
        '<div class="modal-formheader"><h4>' +
          quotemodal.i18n.formTitle +
          '</h4><p class="details-required">' +
          quotemodal.i18n.helpText +
          '</p></div>',
      ),
    );
    $('#quoteDownloadModal .js-productName').parent().append('<p class="mrrp"></p>');
  }

  static updateProduct(productName, price) {
    if (productName) {
      $('#quoteDownloadModal .js-productName').html(productName);
      if (price && Number(price.replace(/[^0-9.-]+/g, '')) > 0) {
        $('#quoteDownloadModal .mrrp').html(quotemodal.i18n.mrrpText + ' ' + price);
        $('#quoteDownloadModal .mrrp').css('display', 'block');
      } else {
        $('#quoteDownloadModal .mrrp').css('display', 'none');
      }
    }
  }

  static setEmailFieldTypes() {
    var input = $('#quoteDownloadModal input[id="email"]');
    if (input) {
      input.attr('type', 'email');
    }
  }

  static insertOtherProductsCheckbox() {
    var t = '<div class="additional-products-container">';
    t +=
      '<div class="form-group additional-products flex justify-content-between align-items-center">';
    t +=
      '<label for="checkbox" class="additional-products--lbl">Looking for other JCB products?</label>';
    t += '<div class="input-wrap">';
    t += '<input class="js--other-products-checkbox" id="checkbox" type="checkbox">';
    t += '<label class="switch-toggle--container"  aria-hidden="true">';
    t +=
      '<div class="switch-toggle"></div><span class="switch-toggle--lbl">YES</span><span class="switch-toggle--lbl">NO</span></label></div>';
    t += '</div>';
    t +=
      '<p class="form-group additional-products--text">Our sales team can provide pricing for these over the phone when we call you.</p>';
    t +=
      '<div class="textarea-box form-group other-poducts-comments-input js--other-poducts-comments-input">';
    t +=
      '<label _conv_done="1" _conv_id="2192" style="zoom: 1;" for="furtherDetails">Provide any further details</label>';
    t +=
      '<div class="input-wrap"><textarea name="furtherDetails" id="furtherDetails" class="furtherDetails"></textarea>';
    t += '</div>';
    t += '</div>';
    t += '</div>';
    $('#quoteDownloadModal .col-sm-12.col-md-12').last().prev().append(t);
  }

  static insertInputValidationTicks() {
    var t =
      '<div class="validation-tick"><svg version="1.1" id="tick" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 37 37" style="enable-background:new 0 0 37 37;" xml:space="preserve"><polyline class="tick path" style="fill:none;stroke:#000;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" points="11.6,20 15.9,24.2 26.4,13.8 "></polyline></svg></div>';

    $('#quoteDownloadModal .input-box.form-group .input-wrap input:not([type="hidden"])').each(
      function () {
        $(this).parent().append(t);
      },
    );
  }

  static testRegex(regex, val) {
    if (regex) {
      var regexStr = RegExp(regex);
      return regexStr.test(val) ? true : false;
    }
    return false;
  }

  static isFieldValid(ele) {
    if ($(ele).attr('data-val-regex-pattern')) {
      return quotemodal.testRegex($(ele).attr('data-val-regex-pattern'), $(ele).val());
    }
    return true;
  }
}
